import { render, staticRenderFns } from "./customButton.vue?vue&type=template&id=d117e6ca"
import script from "./customButton.vue?vue&type=script&lang=js"
export * from "./customButton.vue?vue&type=script&lang=js"
import style0 from "./customButton.vue?vue&type=style&index=0&id=d117e6ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports